<template>

    <v-layout row justify-end align-center>

        <v-btn
            color="secondaryButtonColor"
            v-if="torzsAdat"
            small
            @click="inkabbUjUgyfel()"
            class="button ugy-ugyfel-btn mr-5"
            style="color: var(--v-secondaryButtonTextColor-base)"
        >
            Inkább új ügyfél

        </v-btn>

        <v-dialog v-model="dialog" max-width="85vw" persistent>

            <template v-slot:activator="{ on }">

                <v-btn
                    color="secondary"
                    class="button"
                    v-on="on"
                >

                    <v-icon>{{ icons.mdiAccountSearch }}</v-icon>

                </v-btn>

            </template>

            <v-card>

                <v-card-title class="headline">

                            Ügyfél keresése

                </v-card-title>

                <v-card-text>

                    <v-layout wrap row justify-start>

                        <v-flex md3 class="ma-5">

                            <v-select color="secondary"
                                        v-model="ugyfel.nem"
                                        label="Neme"
                                        item-text="value"
                                        item-value="key"
                                        ref="nem"
                                        :disabled="(
                                            (
                                            path === 'tulajdonos'
                                            && oldal === KGFB_AJANLATI_ADATOK
                                            )
                                            || disabledInput.includes('nem'))"
                                        :items="nem"
                                        :outlined="cfg.props.outlined"
                                        :placeholder="cfg.props.outlined ? ' ' : ''"
                            />

                        </v-flex>

                        <v-flex md3 class="ma-5">

                            <v-text-field
                                color="secondary"
                                v-model="ugyfel.nev"
                                @keydown.enter="ugyfelKeres()"
                                @keyup="ugyfel.nev = capitalize(ugyfel.nev)"
                                label="Név"
                                :outlined="cfg.props.outlined"
                                :placeholder="cfg.props.outlined ? ' ' : ''"
                                :disabled="(
                                        path === 'tulajdonos' && (oldal === KGFB_AJANLATI_ADATOK && vanCasco)
                                        ) || (
                                            disabledInput.includes('nev')
                                        )"
                            />

                        </v-flex>

                        <v-flex v-if="ugyfel.nem != 3" md3 class="ma-5">

                            <BnDate
                                v-model="ugyfel.szulido"
                                :key="szulidokey"
                                @keydown.enter="ugyfelKeres()"
                                :standalone="true"
                                :attributes="{
                                            editable: !(path === 'tulajdonos'
                                            && (oldal === KGFB_AJANLATI_ADATOK && vanCasco)
                                            ),
                                            label: 'Születési idő',
                                    }"
                            />

                        </v-flex>

                        <v-flex v-if="isHibridAvailable" md1 class="ma-5">
                            <v-switch
                                color="secondary"
                                label="Hibrid kötés"
                                :input-value="$store.getters.isHibrid"
                                @change="$store.commit('setHibrid', $event)"
                            ></v-switch>
                        </v-flex>

                    </v-layout>

                    <v-simple-table  v-if="ugyfelLista.length">

                        <template v-slot:default>

                            <thead>

                            <tr>

                                <th class="text-left">Név</th>

                                <th class="text-left">Cím</th>

                                <th class="text-left">
                                  {{ugyfelLista[0].ugyfnem === 3 ? 'Adószám' : 'Születési idő' }}
                                </th>

                                <th class="text-left">Üzletkötő</th>

                                <th class="text-left">Megbízási</th>

                                <th v-if="isHibridAvailable" class="text-left">E-mail</th>

                                <th v-if="isHibridAvailable" class="text-left">Megerősítve</th>

                                <th> Betöltés</th>

                                <th> Törlés</th>

                            </tr>

                            </thead>

                            <tbody>

                                <BnUgyfelKivalasztUgyfelRow
                                    @select-ugyfel="selectUgyfel($event)"
                                    @delete-ugyfel="deleteUgyfel($event.ugyfel, $event.index)"
                                    @email-changed="ugyfel.email = $event"
                                    @ugyfel-keres="ugyfelKeres()"
                                    v-for="(ugyfel, index) in ugyfelLista"
                                    :key="index"
                                    :index="index"
                                    :ugyfel="ugyfel"
                                    :is-hibrid="$store.getters.isHibrid"
                                    :path="path"
                               />

                            </tbody>

                        </template>

                    </v-simple-table>

                    <v-flex md12>

                        <v-progress-linear v-if="loading" :indeterminate="true"/>

                        <v-alert v-if="notFound && !loading" type="warning">

                            {{ errorMsg }}

                            <a
                                target="_blank"
                                :href="`/app/bazisnet3#/master-data/clients/new`">
                                Új ügyfél felvétele
                            </a>

                        </v-alert>

                    </v-flex>

                </v-card-text>

                <v-card-actions>

                    <v-spacer/>

                    <v-btn
                        color="primaryButtonColor"
                        style="color: var(--v-primaryButtonTextColor-base);"
                        class="button"
                        @click.native="megse()"
                    >
                        {{ cancelText }}
                    </v-btn>

                    <v-btn
                        color="secondaryButtonColor"
                        style="color: var(--v-secondaryButtonTextColor-base);"
                        class="button"
                        :disabled="loading"
                        :text="ugyfelLista.length !== 0"
                        @click.native="ugyfelKeres()"
                    >
                        {{ notFound ? 'Új keresés' : 'Keresés' }}
                    </v-btn>

                </v-card-actions>

            </v-card>

        </v-dialog>

    </v-layout>

</template>

<script>
import { mdiAccountSearch } from '@mdi/js';
import ugyfelTorzsService from '../../services/UgyfeltorzsService';
import DateFormat from '../../utils/DateFormat';
import EventBus from '../../modules/EventBus';
import BnDate from './BnDate.vue';
import modozat from '../gfb/shared/mixins/modozat';
import { KGFB_AJANLATI_ADATOK, ALAPADATOK } from '../../modules/Scenario';
import BnUgyfelKivalasztUgyfelRow from './BnUgyfelKivalasztUgyfelRow.vue';
import { capitalize } from '../../filters/capitalize';

export default {
    mixins: [modozat],
    data: () => ({
        clientEmailConfirmationCode: null,
        KGFB_AJANLATI_ADATOK,
        icons: {
            mdiAccountSearch,
        },
        notFound: false,
        errorMsg: null,
        dialog: false,
        loading: false,
        ugyfel: {
            nem: '',
            nev: '',
            szulido: '',
        },
        nem: [
            {
                key: 1,
                value: 'Természetes személy',
            },
            {
                key: 3,
                value: 'Nem természetes személy',
            },
        ],
        ugyfelLista: [],
        szulidokey: 0,
    }),

    components: {
        BnUgyfelKivalasztUgyfelRow,
        BnDate,
    },

    props: {
        oldal: {
            type: Number,
            default: ALAPADATOK,
        },
        path: {
            type: String,
            default: 'ugyfel',
        },
        showUgyfeltorzs: {
            type: Boolean,
            default: false,
        },
        modozat: {
            type: Number,
            required: false,
            default: 2,
        },
        setUgyfelAdditionalData: {
            type: Function,
            required: false,
            default: () => {
            },
        },
        disabledInput: {
            type: Array,
            required: false,
            default: () => [],
        },
    },

    mounted() {
        this.ugyfel.nem = this.normalizeGender(this.sexStore);
        this.ugyfel.nev = this.nameStore;
        this.ugyfel.szulido = this.birthDateStore;
        EventBus.$on('show-ugyfeltorzs', (ugyfelParams) => {
            this.openUgyfelKivalaszto(ugyfelParams);
        });
    },

    watch: {
        nameStore(val) {
            this.ugyfel.nev = val;
        },
        sexStore(val) {
            this.ugyfel.nem = this.normalizeGender(val);
        },
        birthDateStore(val) {
            this.ugyfel.szulido = val;
            this.szulidokey += 1;
        },
        dialog(val) {
            if (!val || this.ugyfel.nem) return;
            if (this.sexStore) this.ugyfel.nem = this.normalizeGender(this.sexStore);
            else this.ugyfel.nem = (this.nameStore || this.birthDateStore) ? 1 : null;
        },
    },

    computed: {
        isHibridAvailable() {
            return this.$store.getters.getBroker.ceg === 1 || this.$store.getters.getBroker.ceg === 307;
        },
        cancelText() {
            if (this.path === 'finanszirozo') {
                return 'Inkább új finanszirozo';
            }
            return this.notFound ? 'Inkább új ügyfél' : 'Mégse';
        },
        nameStore() {
            if (this.path === 'tulajdonos') {
                if (this.$store.getters.tulajdonos.sex === 3) {
                    return this.$store.getters.tulajdonos.cegnev;
                }
                return this.$store.getters.tulajdonos.name;
            }
            if (this.path === 'uzembentarto') {
                if (this.$store.getters.uzembentarto.sex === 3) {
                    return this.$store.getters.uzembentarto.cegnev;
                }
                return this.$store.getters.uzembentarto.name;
            }
            if (this.path === 'finanszirozo') {
                if (this.$store.getters.finanszirozo.sex === 3) {
                    return this.$store.getters.finanszirozo.cegnev;
                }
                return this.$store.getters.finanszirozo.name;
            }
            if (this.path === 'szerzodo') {
                if (this.$store.getters.szerzodo.nem === 3) {
                    return this.$store.getters.szerzodo.szerzodo_cegnev;
                }
                return this.$store.getters.szerzodo.szerzodo_nev;
            }
            throw new Error('BnUgyfelKivalaszt path error');
        },

        sexStore() {
            if (this.path === 'tulajdonos') {
                return this.$store.getters.tulajdonos.sex;
            }
            if (this.path === 'uzembentarto') {
                return this.$store.getters.uzembentarto.sex;
            }
            if (this.path === 'finanszirozo') {
                return this.$store.getters.finanszirozo.sex;
            }
            if (this.path === 'szerzodo') {
                return this.$store.getters.szerzodo.nem;
            }
            throw new Error('sexStore path error');
        },
        birthDateStore() {
            if (this.path === 'tulajdonos') {
                return this.$store.getters.tulajdonos.birthdate;
            }
            if (this.path === 'uzembentarto') {
                return this.$store.getters.uzembentarto.birthdate;
            }
            if (this.path === 'finanszirozo') {
                return this.$store.getters.finanszirozo.birthdate;
            }
            if (this.path === 'szerzodo') {
                return this.$store.getters.szerzodo.szerzodo_szuletesi_ido;
            }
            throw new Error('birthDateStore path error');
        },
        torzsAdat() {
            if (this.path === 'uzembentarto') {
                return this.$store.getters.uzembentarto?.ugyfazon > 0;
            }
            if (this.path === 'tulajdonos') {
                return this.$store.getters.tulajdonos?.ugyfazon > 0;
            }
            if (this.path === 'finanszirozo') {
                return this.$store.getters.finanszirozo?.ugyfazon > 0;
            }
            if (this.path === 'szerzodo') {
                return this.$store.getters.szerzodo?.ugyfazon
                    && typeof this.$store.getters.szerzodo?.ugyfazon === 'number';
            }
            throw new Error('BnUgyfel kivalaszt not implemented path');
        },
    },

    methods: {
        capitalize,
        resetSearchForm() {
            this.ugyfel = {
                nem: this.normalizeGender(this.sexStore),
                nev: this.nameStore,
                szulido: this.birthDateStore,
            };
            this.szulidokey += 1;
            this.ugyfelLista = [];
        },
        clearUgyfelData() {
            this.resetSearchForm();

            if (this.path === 'finanszirozo') {
                const finanszResetArray = [
                    { cegforma: undefined },
                    { company_taxnumber: undefined },
                    { ugyfazon: undefined },
                ];

                finanszResetArray.forEach((item) => {
                    const key = Object.keys(item)[0];
                    const value = item[key];
                    this.$store.commit('setProp', {
                        path: `${this.path}.${key}`,
                        value,
                    });
                });
                [
                    'zip',
                    'city_code',
                    'building',
                    'cityname',
                    'door',
                    'f_ktid',
                    'floor',
                    'floor_name',
                    'house_nr_from',
                    'house_nr_to',
                    'kobe_street_id',
                    'posta_street_type',
                    'street_id',
                    'street_name',
                    'street_type',
                    'street_type_name',
                ].forEach((value) => {
                    this.$store.commit('setProp', {
                        path: `${this.path}.address.${value}`,
                        value: undefined,
                    });
                });
            }

            if (this.path === 'tulajdonos') {
                const tulajResetArray = [
                    { sex: undefined },
                    { cegnev: undefined },
                    { cegforma: undefined },
                    { kepviselo_neve: undefined },
                    { kepviselo_beosztasa: undefined },
                    { kepviselo_telefonszama: undefined },
                    { company_taxnumber: undefined },
                    { teaor: undefined },
                    { name: undefined },
                    { leanynev: undefined },
                    { szulhely: undefined },
                    { anyanev: undefined },
                    { adoszam: undefined },
                    { okm_tipus: undefined },
                    { okm_szam: undefined },
                    { okm_kiallito: undefined },
                    { allampolgarsag: undefined },
                    { mobil: undefined },
                    { telefon: undefined },
                    { email: undefined },
                    { titulus: undefined },
                    { has_licence: undefined },
                    { licence_date: undefined },
                    { birthdate: undefined },
                    { ugyfazon: undefined },
                ];

                const excludedFields = [];
                if (this.oldal === KGFB_AJANLATI_ADATOK) {
                    excludedFields.push('sex');
                }
                if (this.vanCasco && this.oldal === KGFB_AJANLATI_ADATOK) {
                    excludedFields.push('name');
                    excludedFields.push('cegnev');
                    excludedFields.push('birthdate');
                }

                tulajResetArray.filter(((value) => !excludedFields.includes(Object.keys(value)[0])))
                    .forEach((item) => {
                        const key = Object.keys(item)[0];
                        const value = item[key];
                        this.$store.commit('setProp', {
                            path: `${this.path}.${key}`,
                            value,
                        });
                    });
                if (!this.vanCasco || this.oldal === ALAPADATOK) {
                    this.$store.commit('setProp', {
                        path: `${this.path}.address.zip`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.address.city_code`,
                        value: undefined,
                    });
                }

                [
                    'building',
                    'cityname',
                    'door',
                    'f_ktid',
                    'floor',
                    'floor_name',
                    'house_nr_from',
                    'house_nr_to',
                    'kobe_street_id',
                    'posta_street_type',
                    'street_id',
                    'street_name',
                    'street_type',
                    'street_type_name',
                ].forEach((value) => {
                    this.$store.commit('setProp', {
                        path: `${this.path}.address.${value}`,
                        value: undefined,
                    });
                });
                [
                    'building',
                    'city_code',
                    'cityname',
                    'door',
                    'f_ktid',
                    'floor',
                    'floor_name',
                    'house_nr_from',
                    'house_nr_to',
                    'kobe_street_id',
                    'posta_street_type',
                    'street_id',
                    'street_name',
                    'street_type',
                    'street_type_name',
                    'zip',
                ].forEach((value) => {
                    this.$store.commit('setProp', {
                        path: `${this.path}.mail_address.${value}`,
                        value: undefined,
                    });
                });
            }

            if (this.path === 'uzembentarto') {
                // resetCommon
                (() => {
                    this.$store.commit('setProp', {
                        path: `${this.path}.ugyfazon`,
                        value: 0,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.sex`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.email`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.mobil`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.address.zip`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.address.city_code`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.has_licence`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.jogsi_datum`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.licence_date`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.b_kat_licence_date`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: 'tarifaData.b_kat_licence_date',
                        value: undefined,
                    });
                })();

                // resetPerson
                (() => {
                    this.$store.commit('setProp', {
                        path: `${this.path}.mkb_munkahely`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.adoig`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.birthdate`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.titulus`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.name`,
                        value: undefined,
                    });
                })();

                // resetCompany
                (() => {
                    this.$store.commit('setProp', {
                        path: `${this.path}.cegnev`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.cegforma`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.company_taxnumber`,
                        value: undefined,
                    });
                    this.$store.commit('setProp', {
                        path: `${this.path}.teaor`,
                        value: undefined,
                    });
                })();
            }

            if (this.path === 'szerzodo') {
                this.$store.commit('setProp', {
                    path: this.path,
                    value: {
                        ugyfazon: null,
                        nem: null,
                        szerzodo_titulus: 0,
                        szerzodo_nev: '',
                        szerzodo_szuletesi_ido: '',
                        szerzodo_cegforma: null,
                        szerzodo_is_biztositott: false,
                    },
                });

                if (this.setUgyfelAdditionalData) {
                    this.setUgyfelAdditionalData();
                }
            }

            this.$emit('clear-ugyfel-data');
        },

        megse() {
            if (
                this.$store.getters.isHibrid
                && !this.$store.getters.isClientEmailConfirmed
                && this.path !== 'finanszirozo'
                && this.path !== 'tulajdonos'
            ) {
                this.confirm({
                    // eslint-disable-next-line no-useless-concat,max-len
                    message: 'A választott ügyfél email címe nincs megerősítve. A tarifálás hagyományos kötés lesz.\n' + 'Amennyiben hibrid kötést szeretne, úgy válassza ki újra az ügyfelet és küldje el az email cím megerősítő levelet, majd annak ügyfél általi elfogadása után frissítse a felületet',
                    okFn: () => {
                        this.$store.commit('setHibrid', false);
                    },
                });
            }
            if (this.notFound) {
                if (this.ugyfel.nem === 3) {
                    this.$store.commit('setProp', {
                        path: `${this.path}.sex`,
                        value: this.ugyfel.nem,
                    });
                    if (this.ugyfel.nev) {
                        this.$store.commit('setProp', {
                            path: `${this.path}.cegnev`,
                            value: this.ugyfel.nev,
                        });
                    }
                } else if (this.ugyfel.nem === 1 || this.ugyfel.nem === 2) {
                    this.$store.commit('setProp', {
                        path: `${this.path}.sex`,
                        value: (this.sexStore === 1 || this.sexStore === 2) ? this.sexStore : null,
                    });
                    if (this.ugyfel.nev) {
                        this.$store.commit('setProp', {
                            path: `${this.path}.name`,
                            value: this.ugyfel.nev,
                        });
                    }
                    if (this.ugyfel.szulido) {
                        this.$store.commit('setProp', {
                            path: `${this.path}.birthdate`,
                            value: this.ugyfel.szulido,
                        });
                    }
                }
            }
            this.resetSearchForm();
            this.dialog = false;
        },

        inkabbUjUgyfel() {
            this.$store.commit('setProp', {
                path: `${this.path}.szerzodo_is_biztositott`,
                value: false,
            });

            this.dialog = false;

            if (this.setUgyfelAdditionalData) {
                this.setUgyfelAdditionalData();
            }

            this.clearUgyfelData();
        },

        openUgyfelKivalaszto(ugyfelparams) {
            if (!!ugyfelparams.nem
                && (
                    (!!ugyfelparams.nev)
                    || !!ugyfelparams.cegnev
                )
            ) {
                this.dialog = true;
                this.ugyfel = {...ugyfelparams, nem: this.normalizeGender(ugyfelparams.nem)};
                this.resetSearchForm();
                this.ugyfelKeres(); // azért egyből kezdje el keresni
            }
        },

        ugyfelKeres() {
            this.loading = true;
            ugyfelTorzsService.getUgyfelListOldApi(
                DateFormat.plainToDashed(this.ugyfel.szulido),
                null,
                10,
                this.ugyfel.nem,
                this.ugyfel.nev,
                1,
            )
                .then((response) => {
                    this.ugyfelLista = response.data.data;
                    if (
                        typeof this.ugyfelLista === 'object'
                        && this.ugyfelLista.length === 0
                    ) {
                        this.notFound = true;
                        this.errorMsg = response.data.error;
                    } else {
                        this.notFound = false;
                        this.errorMsg = null;
                    }
                    this.loading = false;
                });
        },

        selectUgyfel(ugyfel) {
            const setTulajdonosData = (response) => {
                const receivedUgyfel = response.data.ugyfel;
                if (this.oldal === ALAPADATOK) {
                    receivedUgyfel.name = receivedUgyfel.nev;
                    receivedUgyfel.birthdate = receivedUgyfel.szulido;
                    receivedUgyfel.address = {};
                    receivedUgyfel.address.zip = receivedUgyfel.irsz;
                    receivedUgyfel.address.city_code = receivedUgyfel.varos;
                }

                receivedUgyfel.address.lock_coz_load = true;
                if (receivedUgyfel.mail_address) {
                    receivedUgyfel.mail_address.lock_coz_load = true;
                }

                this.$store.dispatch('setUgyfel', {
                    path: this.path,
                    value: receivedUgyfel,
                });

                this.$store.commit('setProp', {
                    path: 'tulajdonos.ugyfazon',
                    value: ugyfel.ugyfazon,
                });
            };
            switch (this.path) {
            case 'finanszirozo':
                ugyfelTorzsService.getUgyfel(ugyfel.ugyfazon, Number(this.modozat))
                    .then((response) => {
                        const ugyf = response.data.ugyfel;
                        ugyf.szerzodo_is_biztositott = false;

                        this.$store.dispatch('setUgyfel', {
                            path: this.path,
                            value: ugyf,
                        });
                        this.$store.commit('setProp', {
                            path: `${this.path}.ugyfazon`,
                            value: ugyfel.ugyfazon,
                        });

                        if (this.setUgyfelAdditionalData) {
                            this.setUgyfelAdditionalData();
                        }
                    });
                this.dialog = false;
                this.clearUgyfelData();
                break;
            case 'uzembentarto':
                ugyfelTorzsService.getUgyfel(ugyfel.ugyfazon, Number(this.modozat))
                    .then((response) => {
                        const ugyf = response.data.ugyfel;
                        ugyf.szerzodo_is_biztositott = false;

                        this.$store.dispatch('setUgyfel', {
                            path: this.path,
                            value: ugyf,
                            torzsadat: true,
                        });
                        this.$store.commit('setProp', {
                            path: `${this.path}.ugyfazon`,
                            value: ugyfel.ugyfazon,
                        });

                        if (this.setUgyfelAdditionalData) {
                            this.setUgyfelAdditionalData();
                        }
                    });
                this.dialog = false;
                this.clearUgyfelData();
                break;
            case 'tulajdonos':
                if (this.oldal === KGFB_AJANLATI_ADATOK) {
                    ugyfelTorzsService.getTulajdonos(
                        this.$store.getters.tarifaData.id,
                        ugyfel.ugyfazon,
                    )
                        .then(setTulajdonosData);
                }
                if (this.oldal === ALAPADATOK) {
                    ugyfelTorzsService.getUgyfel(
                        ugyfel.ugyfazon,
                        Number(this.modozat),
                    )
                        .then(
                            setTulajdonosData,
                        );
                }
                this.dialog = false;
                this.clearUgyfelData();
                break;
            case 'szerzodo':
                ugyfelTorzsService.getUgyfel(ugyfel.ugyfazon, Number(this.modozat))
                    .then((response) => {
                        const ugyf = response.data.ugyfel;
                        ugyf.szerzodo_is_biztositott = false;

                        this.$store.dispatch('setUgyfel', {
                            path: this.path,
                            value: ugyf,
                        });

                        if (this.setUgyfelAdditionalData) {
                            this.setUgyfelAdditionalData();
                        }
                    });

                this.dialog = false;
                /* this.clearUgyfelData(); */
                break;
            default:
                throw new Error('Logic for this path is not implemented yet. (BnUgyfelKivalaszt selectUgyfel)');
            }
        },

        deleteUgyfel(ugyfel, index) {
            this.confirm({
                title: 'Ügyfél törlése',
                message: 'Biztosan törölni kívánja az ügyfelet az ügyféltörzsből?',
                okFn: () => {
                    ugyfelTorzsService.deleteUgyfel(ugyfel.ugyfazon)
                        .then(() => {
                            this.ugyfelLista.splice(index, 1);
                        });
                },
                closeText: 'Mégse',
                okText: 'Ügyfél törlése',
            });
        },

        normalizeGender(value) {
            return (value === 1 || value === 2) ? 1 : value;
        }
    },
};
</script>
<style scoped>
.snackbar {
    font-size: 20px;
}
.uj-ugyfel-btn {
    margin-right: 20px;
    margin-top: 3px;
    color:var(--v-secondaryButtonTextColor-base);
}
</style>
